<template>
  <header @mouseleave="clearActiveMenu" :class="{ 'nav-closing': navClosing }">
    <div class="header-container">
      <!-- 로고 영역 -->
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/images/bloan_logo.svg" alt="SO WORLD STOCK LOAN">
        </router-link>
      </div>
      
      <!-- 햄버거 버튼 (모바일) -->
      <button class="hamburger-btn" :class="{ active: mobileMenuOpen }" @click="toggleMobileMenu" aria-label="메뉴">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>

      <!-- 메인 네비게이션 -->
      <nav class="main-nav" :class="{ 'mobile-open': mobileMenuOpen }">
        <ul class="main-menu">
          <!-- 상품안내 메뉴 -->
          <li 
            :class="{ 'mobile-sub-open': openMobileMenu === 0, 'active': activeMenuIndex === 0 }"
            @mouseenter="setActiveMenu(0)"
          >
            <a href="javascript:void(0)" class="main-menu-trigger" @click="toggleSubMenu(0)">상품안내<span class="mobile-arrow"></span></a>
            <ul class="sub-menu">
              <div class="sub-menu-container">
                <li><router-link to="/info/so_c1010" @click="closeMobileMenu">대출상품안내</router-link></li>
                <li><router-link to="/info/so_c1020" @click="closeMobileMenu">대출절차</router-link></li>
                <li><router-link to="/info/so_c1030" @click="closeMobileMenu">대출신청시 유의사항</router-link></li>
              </div>
            </ul>
          </li>
          
          <!-- 대출신청 메뉴 -->
          <li 
            :class="{ 'mobile-sub-open': openMobileMenu === 1, 'active': activeMenuIndex === 1 }"
            @mouseenter="setActiveMenu(1)"
          >
            <a href="javascript:void(0)" class="main-menu-trigger" @click="toggleSubMenu(1)">대출신청<span class="mobile-arrow"></span></a>
            <ul class="sub-menu">
              <div class="sub-menu-container">
                <li><router-link to="/loan/so_c2005" @click="closeMobileMenu">증권계좌등급 조회</router-link></li>
                <li><router-link to="/loan/so_c2030" @click="closeMobileMenu">신규대출 신청</router-link></li>
                <li><router-link to="/loan/so_c2040" @click="closeMobileMenu">추가대출 신청</router-link></li>
              </div>
            </ul>
          </li>
          
          <!-- 계좌운영규칙 메뉴 -->
          <li 
            :class="{ 'mobile-sub-open': openMobileMenu === 2, 'active': activeMenuIndex === 2 }"
            @mouseenter="setActiveMenu(2)"
          >
            <a href="javascript:void(0)" class="main-menu-trigger" @click="toggleSubMenu(2)">계좌운영규칙<span class="mobile-arrow"></span></a>
            <ul class="sub-menu">
              <div class="sub-menu-container">
                <li><router-link to="/account-rules/so_c3004" @click="closeMobileMenu">SO월드스탁론 Pro</router-link></li>
                <!-- Prime/Max는 현재 미운영(Pro 통합). 재오픈 시 아래 주석 해제
                <li><router-link to="/account-rules/so_c3002" @click="closeMobileMenu">국내,해외 통합형</router-link></li>
                <li><router-link to="/account-rules/so_c3003" @click="closeMobileMenu">지수형ETF 전용</router-link></li>
                -->
              </div>
            </ul>
          </li>
          
          <!-- 마이페이지 메뉴 -->
          <li 
            :class="{ 'mobile-sub-open': openMobileMenu === 3, 'active': activeMenuIndex === 3 }"
            @mouseenter="setActiveMenu(3)"
          >
            <a href="javascript:void(0)" class="main-menu-trigger" @click="toggleSubMenu(3)">마이페이지<span class="mobile-arrow"></span></a>
            <ul class="sub-menu">
              <div class="sub-menu-container">
                <li><router-link to="/mypage/so_c4010" @click="closeMobileMenu">대출거래정보</router-link></li>
                <li><router-link to="/mypage/so_c4020" @click="closeMobileMenu">상환/해지</router-link></li>
                <li><router-link to="/mypage/so_c4030" @click="closeMobileMenu">만기연장</router-link></li>
                <li><router-link to="/mypage/so_c4040" @click="closeMobileMenu">나의 질문답변</router-link></li>
                <li><router-link to="/auth/edit-profile" @click="closeMobileMenu">개인정보관리</router-link></li>
                <li><router-link to="/auth/change-password" @click="closeMobileMenu">비밀번호 변경</router-link></li>
              </div>
            </ul>
          </li>
          
          <!-- 고객센터 메뉴 -->
          <li 
            :class="{ 'mobile-sub-open': openMobileMenu === 4, 'active': activeMenuIndex === 4 }"
            @mouseenter="setActiveMenu(4)"
          >
            <a href="javascript:void(0)" class="main-menu-trigger" @click="toggleSubMenu(4)">고객센터<span class="mobile-arrow"></span></a>
            <ul class="sub-menu">
              <div class="sub-menu-container">
                <li><router-link to="/support/so_c5030" @click="closeMobileMenu">공지사항</router-link></li>
                <li><router-link to="/support/so_c5010" @click="closeMobileMenu">FAQ</router-link></li>
                <li><router-link to="/support/so_c5040" @click="closeMobileMenu">1:1 문의</router-link></li>
                <li><router-link to="/support/so_c5020" @click="closeMobileMenu">약관·약정서 보기</router-link></li>
              </div>
            </ul>
          </li>
        </ul>

        <!-- 모바일 인증 버튼 -->
        <div class="mobile-auth-buttons">
          <router-link to="/auth/login" class="btn-login" @click="closeMobileMenu">로그인</router-link>
          <router-link to="/auth/signup" class="btn-signup" @click="closeMobileMenu">회원가입</router-link>
        </div>
      </nav>
      
      <!-- 인증 버튼들 (데스크톱) -->
      <div class="auth-buttons">
        <router-link to="/auth/login" class="btn-login">로그인</router-link>
        <router-link to="/auth/signup" class="btn-signup">회원가입</router-link>
      </div>
    </div>
    <div 
      class="sub-menu-bg" 
      :class="{ 'show': activeMenuIndex !== null }"
    ></div>
  </header>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'

const mobileMenuOpen = ref(false)
const openMobileMenu = ref(null)
const activeMenuIndex = ref(null)
const navClosing = ref(false)
const route = useRoute()

function setActiveMenu(index) {
  if (window.innerWidth > 768) {
    activeMenuIndex.value = index
  }
}

function clearActiveMenu() {
  if (window.innerWidth > 768) {
    activeMenuIndex.value = null
  }
}

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
  if (!mobileMenuOpen.value) {
    openMobileMenu.value = null
  }
}

function closeMobileMenu() {
  navClosing.value = true
  mobileMenuOpen.value = false
  openMobileMenu.value = null
  activeMenuIndex.value = null
  nextTick(() => { navClosing.value = false })
}

function toggleSubMenu(index) {
  if (window.innerWidth <= 768) {
    openMobileMenu.value = openMobileMenu.value === index ? null : index
  }
}

// 라우트 변경 시 메뉴 닫기
watch(() => route.path, () => {
  closeMobileMenu()
})
</script>

<style src="@/assets/styles/style.css"></style>
